import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ActivitySubscriptionType } from '@recruitee/activities-types';
import type {
  ActivitySubscriptionEvent,
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { DevFlagsModule } from '@recruitee/dev-flags';
import { TranslatePipe } from '@recruitee/i18n';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-me',
  templateUrl: './activity-subscriptions-me.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  standalone: true,
  imports: [
    ActivitySubscriptionsTableComponent,
    TranslatePipe,
    ActivitySubscriptionsTableRowComponent,
    DevFlagsModule,
  ],
})
export class ActivitySubscriptionsMeComponent {
  @Input() public types: ActivitySubscriptionType[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public hasRequisitions = false;
  @Input() public abilities = {
    viewRequisitions: false,
  };
  @Output() public changeEvents: EventEmitter<ActivitySubscriptionUpdateData> = new EventEmitter();

  public assignmentEventsGroup: ActivitySubscriptionEvent[] = [
    'assignmentAdd',
    'assignmentRemove',
    'interviewEventRemove',
    'interviewEventChange',
    'interviewResultRequested',
    'requisitionAssignmentAdd',
    'requisitionAssignmentRemove',
    'candidateAccessReceived',
  ];
}
